<template>
  <content-panel :title="title" :icon="WorkflowIcon">
    <div v-if="loading" class="flex flex-col gap-3">
      <ui-skeleton class="h-4 w-4/5" />
      <ui-skeleton class="h-4 w-3/5" />
      <ui-skeleton class="h-4 w-11/12" />
    </div>

    <div v-else-if="rules.length" class="flex flex-col divide-y divide-border">
      <router-link
        v-for="rule in rules"
        :key="'rule-link--' + rule.id"
        :to="'/automation/' + rule.id + '/overview'"
        class="flex items-start gap-2.5 py-2 text-sm text-foreground no-underline first:pt-0 last:pb-0 hover:text-primary"
      >
        <rule-type-badge compact :action="rule.action" />
        <span class="min-w-0 pt-0.5 break-words">{{ rule.name }}</span>
      </router-link>
    </div>

    <p v-else class="m-0 text-sm text-muted-foreground">
      {{ emptyText }}
    </p>
  </content-panel>
</template>

<script>
import { Workflow } from '@lucide/vue';
import { markRaw } from 'vue';

import ContentPanel from '@/ui/components/ContentPanel.vue';
import RuleTypeBadge from '@/ui/components/RuleTypeBadge.vue';

/** Panel listing linked automations (of a brand or a rule). */
export default {
  name: 'RuleLinksCard',
  components: {
    ContentPanel,
    RuleTypeBadge,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    rules: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    emptyText: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    WorkflowIcon: markRaw(Workflow),
  }),
};
</script>
